import { IPartnerFinSobRow } from '../../model/types'

import { isCanonicalFinSobRow } from './isCanonicalFinSobRow'
import { isRequestedCategoryTotalRow } from './isRequestedCategoryTotalRow'
import { TCategoryRowScope } from './types'

export const isRequestedCategoryRow = (
  row: IPartnerFinSobRow,
  category: string,
  scope: TCategoryRowScope
): boolean =>
  scope === 'subtree' ? isCanonicalFinSobRow(row) : isRequestedCategoryTotalRow(row, category)
